import { createReducer } from '@reduxjs/toolkit';
import { actions } from './actions';
const initialState = {
    certificateCode: '',
    hasError: false,
    hasRedemptionError: false,
    isValidating: false,
    isRedemptionValidating: false,
    redemptionCode: '',
    redemptionValidationResult: '',
    validationResult: '',
};
export const reducer = createReducer(initialState, (builder) => {
    builder
        .addCase(actions.setCertificateCode, (state, { payload }) => ({
        ...state,
        certificateCode: payload,
    }))
        .addCase(actions.setRedemptionCode, (state, { payload }) => ({
        ...state,
        redemptionCode: payload,
    }))
        .addCase(actions.setIsCertificateValidating, (state, { payload }) => ({
        ...state,
        isValidating: payload,
    }))
        .addCase(actions.setIsRedemptionCodeValidating, (state, { payload }) => ({
        ...state,
        isRedemptionValidating: payload,
    }))
        .addCase(actions.setCertificateCodeValidationResult, (state, { payload }) => ({
        ...state,
        validationResult: payload,
    }))
        .addCase(actions.setRedemptionValidationCodeResult, (state, { payload }) => ({
        ...state,
        redemptionValidationResult: payload,
    }))
        .addCase(actions.setHasValidationError, (state, { payload }) => ({
        ...state,
        hasError: payload,
    }))
        .addCase(actions.setHasRedemptionError, (state, { payload }) => ({
        ...state,
        hasRedemptionError: payload,
    }))
        .addCase(actions.setIsDroppedCustomValidation, (state, { payload }) => ({
        ...state,
        isDroppedCustomValidation: payload,
    }));
});
